export default __webpack_public_path__ + "static/media/books.98e96d58.svg";